import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider} from '@mui/material'
import React, {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {hideSaveDialog, toggleSaveDialogSuccess} from '../../store/slice/dialogSlice'
import {LoadingButton} from '@mui/lab'

const SaveDialog = ({handleSave, text, isLoading = false, isDisabled}) => {
    const open = useSelector((state) => state.dialogSlice.saveDialog)
    const dispatch = useDispatch()
    const handleClose = () => {
        dispatch(hideSaveDialog())
        dispatch(toggleSaveDialogSuccess(false))
    }

    const [loadingSubmit, setLoadingSubmit] = useState(false)
    const handleSaveDialog = () => {
        handleSave()
        handleClose()
        setLoadingSubmit(true);
        setTimeout(() => {
            setLoadingSubmit(false)
        }, 1)
        dispatch(hideSaveDialog())
    }


    return (
        <div>
            <Dialog open={open} onClose={handleClose} fullWidth>
                <DialogTitle>Save</DialogTitle>
                <Divider/>
                <DialogContent>
                    <DialogContentText>Are you sure you want to save your changes in {text}?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        disabled={isLoading || isDisabled}
                        loading={loadingSubmit}
                        variant="contained"
                        onClick={handleSaveDialog}
                    >
                        Yes
                    </LoadingButton>

                    <Button variant="outlined" onClick={handleClose} sx={{color: 'gray', borderColor: '#D3D3D3'}}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default SaveDialog
